import AntdIcon from '@ant-design/icons';

import styled from 'styled-components';

export const StyledAntdIcon = styled(AntdIcon)`
  svg {
    height: 100%;
    width: 100%;
    fill: currentcolor;
    color: currentcolor;
  }
`;
